import type { ComponentProps } from 'react'
import { cn } from '@/utils'

/**
 * The staff pages' widths (SA-447): every staff page names one of these
 * instead of writing its own `max-w-*` (pageHeader.guard.test.ts: rule C
 * refuses an own width, rule F a page that names none). Basis-shaped (data-slot, div props, cn) but app-owned: basis is
 * vendored and hash-pinned, and has no page primitive.
 *
 * - `list`: full width inside AppShell's `p-4 lg:p-6`, for registers and lists.
 * - `detail`: 1152px (the SA-340 wireframe's `w-6xl`), for rich pages; the
 *   record lane lays two columns inside it.
 * - `form`: 768px, for a single column of reading or a form.
 */
export type PageWidth = 'list' | 'detail' | 'form'

const WIDTH: Record<PageWidth, string> = {
  list: 'max-w-none',
  detail: 'max-w-6xl',
  form: 'max-w-3xl',
}

export function PageFrame({
  width, className, ...props
}: ComponentProps<'div'> & { width: PageWidth }) {
  return (
    <div
      data-slot="page-frame"
      data-page-width={width}
      className={cn('mx-auto w-full', WIDTH[width], className)}
      {...props}
    />
  )
}
